import { render, staticRenderFns } from "./modalInsertUserFlag.vue?vue&type=template&id=4b6e887f"
import script from "./modalInsertUserFlag.vue?vue&type=script&lang=js"
export * from "./modalInsertUserFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports